module.exports = __webpack_public_path__ + "static/favicon-d0563845e3be4320b818827a38d8ac81.ico";